export class CardMessage {
  constructor(text: string) {
    this.message = text;
  }
  message: string;
}
